;
(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');
	var Model = APP.module('Model');
	var Collection = APP.module('Collection');

	View.AflClubsGauntlet = Marionette.ItemView.extend({
		tagName: 'div',
		template: JST.AflClubsGauntlet,
		data: {},
		gauntlet_start_round: 7,
		initialize: function () {
			this.squads = this.getOption('squads');
			this.rounds = this.getOption('rounds');
			this.model = this.getOption('model');

			this.getting_data = true;

			var collections = [this.squads, this.rounds],
				complete = _.invoke(collections, 'fetch', {
					cache: true,
					expires: 60
				});

			$.when.apply(null, complete).done(_.bind(function () {
				this.loadGauntletWidget();
			}, this));

		},

		loadGauntletWidget: function () {
			var _this = this,
				model = new Model.Gauntlet();
			model
				.loadSnapshot()
				.fetch()
				.done(function (response) {

					response.get = function (k) {
						if (this.result[k]) {
							return this.result[k]
						} else {
							return null
						}
					};


					var snapshot = {
							sended: response.get('sended'),
							is_active: response.get('is_active'),
							active_users: response.get('active_users'),
							total_users: response.get('total_users'),
							eliminated_in: response.get('eliminated_in') || {
								round: 6
							}
						},
						i,
						round_id = _this.rounds.getActualRoundId() < _this.gauntlet_start_round ? _this.gauntlet_start_round : _this.rounds.getActualRoundId(),
						actual_round = _this.rounds.get(round_id),
						team_selected = false;

					if (snapshot.sended && snapshot.is_active) {
						//check for selected team
						for (i = 0; i < snapshot.sended.length; i++) {
							if (snapshot.sended[i].round == actual_round.id) {
								team_selected = true;
								break;
							}
						}
					}

					_this.setTemplateData({
						snapshot: snapshot,
						team_selected: team_selected,
						actual_round: actual_round,
						start_round: _this.rounds.getActualRoundId() >= _this.gauntlet_start_round
					});

				});
		},

		setTemplateData: function (obj) {
			_.extend(this.data, obj);
			this.getting_data = true;
			this.render();
			return this;
		},

		render: function () {

			if (!this.getting_data) {
				return this;
			}

			this.$el.html(this.template(this.data));

			return this;
		}
	})

}(window, APP, Backbone, Marionette, $, _));
